import LogoMRG from './LogoMRG';
import { PAGES } from '../data/constants';

export default function Nav({ currentPage, goTo }) {
  return (
    <nav className="nav">
      <div className="nav-logo" onClick={() => goTo('inicio')} role="button" aria-label="Ir al inicio">
        <LogoMRG />
      </div>
      <ul className="nav-links">
        {PAGES.map((p) => (
          <li key={p}>
            <button
              className={currentPage === p ? 'act' : ''}
              onClick={() => goTo(p)}
            >
              {p.charAt(0).toUpperCase() + p.slice(1)}
            </button>
          </li>
        ))}
        <li>
          <button className="nav-cta" onClick={() => goTo('contacto')}>
            Cotizar
          </button>
        </li>
      </ul>
    </nav>
  );
}
